import _ from 'lodash';

import {
  ShippingServiceWidgetDocument,
  useNetSuiteSettingsWidgetQuery,
  useSaveNetSuiteSettingsMutation
} from 'generated/graphql';
import {
  useCallback,
  useMemo
} from 'react';

import * as types from './types';



export interface IData {
  isTier1: boolean;
  formState: types.IFormState;
}

export function useQuery(storeId: string) {
  const tuple = useNetSuiteSettingsWidgetQuery({
    variables: {
      storeId
    }
  });

  return useMemo(
    () => {
      const data: IData = {
        isTier1: tuple.data?.store?.type.name === 'cleoTier1',
        formState: {
          netSuiteEmployee: tuple.data?.store?.salesRepresentativeEmployee ? {
            id: tuple.data.store.salesRepresentativeEmployee.id,
            displayName: tuple.data.store.salesRepresentativeEmployee.fullName
          } : null,
          packingSlipInformation: tuple.data?.store?.packingSlipInformation ?? '',
          salesChannel: {
            id: tuple.data?.store?.salesChannel.name ?? 'ecommerce',
            displayName: tuple.data?.store?.salesChannel.displayName ?? ''
          },

          netSuiteDepartment: {
            id: tuple.data?.store?.department?.id ?? '',
            displayName: ''
          },

          netSuiteLocation: {
            id: tuple.data?.store?.inventoryLocation?.id ?? '',
            displayName: ''
          },

          netSuiteBrand: {
            id: tuple.data?.store?.brand?.id ?? '',
            displayName: ''
          },

          netSuiteSubsidiary: {
            id: tuple.data?.store?.subsidiary?.id ?? '',
            displayName: ''
          },

          netSuiteTaxItem: {
            id: tuple.data?.store?.taxItem?.id ?? '',
            displayName: ''
          },

          netSuiteClientInternalId: tuple.data?.store?.netSuiteClientInternalId ?? ''
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSaveNetSuiteSettings(storeId: string) {
  const [fnMutate, tuple] = useSaveNetSuiteSettingsMutation({
    refetchQueries: [
      {
        query: ShippingServiceWidgetDocument,
        variables: {
          storeId
        }
      }
    ]
  });

  const fnWrappedMutate = useCallback(
    async (formState: types.IFormState) => {
      await fnMutate({
        variables: {
          storeId,
          salesChannel: formState.salesChannel.id,
          departmentId: formState.netSuiteDepartment.id,
          inventoryLocationId: formState.netSuiteLocation.id,
          brandId: formState.netSuiteBrand.id,
          subsidiaryId: formState.netSuiteSubsidiary.id,
          taxItemId: formState.netSuiteTaxItem.id,
          packingSlipInformation: _.trim(formState.packingSlipInformation),
          netSuiteClientInternalId: formState.netSuiteClientInternalId,
          salesRepresentativeEmployeeId: formState.netSuiteEmployee?.id
        }
      });
    },
    [
      fnMutate,
      storeId
    ]
  );

  return useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
